export const iconFontAwesomeHumanitarianRoadBridge = (
	<i className="fa-solid fa-road-bridge"></i>
);
